import { School, Crown, User, GraduationCap, Rocket } from "lucide-react";

// Built-in plan copy. Name, feature bullets and the "Most Popular" badge can be overridden by the master admin
// (Admin -> Content); prices are display-only and mirror Stripe.
export const STUDENT_PLANS = {
  free: {
    name: "Free Plan",
    price: 0,
    currency: "AUD",
    period: "forever",
    features: [
      "3 warm-up questions daily",
      "1 bonus challenge daily (guest)",
      "3 bonus challenges daily (account)",
      "Basic leaderboard access",
      "Track your progress",
      "Create your own questions"
    ],
    icon: User,
    popular: false
  },
  student: {
    name: "Student Plan",
    price: 8,
    currency: "AUD",
    period: "month",
    features: [
      "8 bonus challenges a day to power through the Campaign",
      "Unlock hints for all questions",
      "Create and share your own questions",
      "Support independent learning"
    ],
    icon: Crown,
    popular: true
  }
};

export const TEACHER_PLANS = {
  school: {
    name: "Teacher Starter License",
    price: 0,
    currency: "AUD",
    period: "forever",
    features: [
      "Run live drills (3 participants max)",
      "Progress tracking for 10 student slots",
      "Assign tailored coding exercises for classroom activities or homework",
      "5 challenges per student per day",
      "Dedicated school leaderboard",
      "Streamlined bulk student onboarding",
      "Comprehensive admin dashboard"
    ],
    icon: School,
    popular: false
  },
  teacher_plus: {
    name: "Teacher Plus",
    price: 14,
    currency: "AUD",
    period: "month",
    features: [
      "Run live drills with up to 20 participants",
      "Progress tracking for 50 student slots",
      "Instant activation — no application needed",
      "Assign coding drills for classwork or homework",
      "5 challenges per student per day",
      "Dedicated school leaderboard",
      "Bulk student onboarding"
    ],
    icon: GraduationCap,
    popular: true
  },
  teacher_pro: {
    name: "Teacher Pro",
    price: 29,
    currency: "AUD",
    period: "month",
    features: [
      "Run live drills with up to 50 participants",
      "Progress tracking for 200 student slots",
      "Instant activation — no application needed",
      "Assign coding drills for classwork or homework",
      "5 challenges per student per day",
      "Dedicated school leaderboard",
      "Bulk student onboarding"
    ],
    icon: Rocket,
    popular: false
  }
};

export const ALL_PLAN_DEFAULTS = { ...STUDENT_PLANS, ...TEACHER_PLANS };
export const PLAN_GROUPS = [
  { id: "student", title: "Student plans", keys: Object.keys(STUDENT_PLANS) },
  { id: "teacher", title: "Teacher plans", keys: Object.keys(TEACHER_PLANS) },
];
